import { render, staticRenderFns } from "./UIBtnRound.vue?vue&type=template&id=7d1bccbd&scoped=true&"
import script from "./UIBtnRound.vue?vue&type=script&lang=ts&"
export * from "./UIBtnRound.vue?vue&type=script&lang=ts&"
import style0 from "./UIBtnRound.vue?vue&type=style&index=0&id=7d1bccbd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1bccbd",
  null
  
)

export default component.exports